// extracted by mini-css-extract-plugin
export default {"actions":"Logs_actions__4QrMP","fecha":"Logs_fecha__7brI3","download":"Logs_download__Gxaoa"};